module.exports = __webpack_public_path__ + "static/media/动力总成.f81045e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/动力总成.png
// module id = 1712
// module chunks = 174